/* eslint-disable dot-notation */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable func-names */
import React, { Component } from 'react';
import PropTypes, { any } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Waypoint from 'react-waypoint';
// import debounce from 'lodash/debounce';
import 'url-search-params-polyfill';
import * as queryString from 'query-string';

import {
    getPickleBallRating,
    getRatingDetails,
    setRatingChoice,
} from '../../../utils';
import Description from '../../text/Description';
import BackgroundImage from '../../BackgroundImage';
import { isValidEmail } from '../../../utils/validation';

import { getApiAxiosInstance } from '../../../utils/network';
import withStatsig from '../../hocs/withStatsig';
import { sportTypeIds } from '../../../utils/eventConstants';

import styles from './playerSearch.scss';
import themeV3styles from '../themeV3.scss';

class PlayerSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showDropDown: false,
            options: [],
            query: '',
            // type: 'PLAYER',
            top: 10,
            skip: 0,
            isEnd: false,
            searched: false,
            // isShowingExpandedSearch: false
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.handleOnFocus = this.handleOnFocus.bind(this);
        // this.handleKeyUp = debounce(this.handleKeyUp.bind(this), 300);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.fetchSearchResults = this.fetchSearchResults.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.loadMoreItems = this.loadMoreItems.bind(this);
        this.handleSearchBackClick = this.handleSearchBackClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.emailTextInput) {
            this.setState({
                emailTextInput: true,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log('PlayerSearch - componentWillReceiveProps');
        console.log(nextProps);
        // for player lookup default search to player (and hide filter buttons)
        /* if (nextProps.mode == 'lookup' && nextProps.lookup) {
            this.setState({
                type: 'PLAYER'
            });
            //open search and set focus on input
            console.log('PlayerSearch props', this.props);
            console.log('PlayerSearch state', this.state);
        } */
        if (nextProps.value || nextProps.allowQueryToBeSetToEmpty) {
            this.setState({
                query: nextProps.value,
            });
        }
    }

    componentDidUpdate() {
        // console.log('PlayerSearch state', this.state);
        // console.log('PlayerSearch props', this.props);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.showDropDown) {
            this.setState({
                showDropDown: false,
            });
        }
    }

    handleOnFocus(event) {
        const { emailTextInput } = this.state;
        if ((!emailTextInput && this.state.query.length > 0) || (emailTextInput && this.state.query.length > 0 && !this.state.query.includes('@'))) {
            this.setState({
                showDropDown: true,
            });
        }
    }

    handleKeyUp(event) {
        console.log('query', event.target.value);
        const query = event.target.value;

        if (this.props.handlePlayerNameTextChange) {
            this.props.handlePlayerNameTextChange(query);
        }

        const { emailTextInput } = this.state;
        let error = null;
        this.props.onChange();
        if (query.length > 0) {
            if (emailTextInput && query.includes('@')) {
                this.setState({
                    isLoading: false,
                    showDropDown: false,
                    query,
                });
                const trimmedEmail = query.toLowerCase().trim();
                if (/\s/.test(trimmedEmail)) {
                    error = 'No whitespace are allowed';
                } else if (!isValidEmail(trimmedEmail)) {
                    error = 'This does not appear to be a valid email';
                } else {
                    // allow direct input of email without searching
                    this.props.handlePlayerSelect(query, this.props.index);
                }
                this.setState({
                    error,
                });
            } else {
                // search for anything that is not email
                this.setState({
                    isLoading: true,
                    showDropDown: true,
                    query,
                    options: [],
                    skip: 0,
                    isEnd: false,
                }, function () {
                    this.fetchSearchResults();
                });
            }
        } else {
            // empty query
            this.setState({
                query: '',
                options: [],
                skip: 0,
                showDropDown: false,
                isEnd: false,
            });
        }
    }

    handlePaste(event) {
        const { target } = event;
        const { emailTextInput } = this.state;
        this.props.onChange();
        setTimeout(() => {
            const query = target.value.trim();
            if (query.length > 0) {
                if (emailTextInput && query.includes('@')) {
                    // allow direct input of email without searching
                    this.setState({
                        isLoading: false,
                        showDropDown: false,
                        query,
                    }, function () {
                        this.props.handlePlayerSelect(query, this.props.index);
                    });
                } else {
                    // search for anything that is not email
                    this.setState({
                        isLoading: true,
                        showDropDown: true,
                        query,
                        options: [],
                        skip: 0,
                        isEnd: false,
                    }, function () {
                        this.fetchSearchResults();
                    });
                }
            } else {
                this.setState({
                    query: '',
                    options: [],
                    showDropDown: false,
                    isEnd: false,
                });
            }
        }, 200);
    }

    fetchSearchResults() {
        console.log('fetchSearchResults', this.state.query, this.state.skip, this.state.options.length);
        const parsed = queryString.parse(this.props.location.search);
        const { jwt } = parsed;

        const axiosInstance = getApiAxiosInstance(jwt);

        const { query, top, skip, isEnd } = this.state;
        const { clubSubTypeId, searchParams, isProximitySearch, clubLocation } = this.props;
        const params = new URLSearchParams();
        params.append('query', query);
        params.append('top', 10);
        params.append('skip', skip);
        if (this.props.searchMembersOnly) {
            params.append('exists', 'memberId');
        }
        if (this.props.showDemoPlayers) {
            params.append('isDemoPlayer', true);
        } else {
            params.append('isDemoPlayer', false);
        }

        if (this.props.excludeProPlayers) {
            params.append('filter', 'isPro:false');
        }

        if (this.props.excludeNonEligiblePlayers) {
            params.append('eligibleForTmsEventId', this.props.eventId);
        }
        if (this.props.claimed) {
            params.append('claimed', true);
        } else {
            params.append('claimed', false);
        }
        if (clubSubTypeId && clubSubTypeId === 1) {
            params.append('gender', 'M');
        } else if (clubSubTypeId && clubSubTypeId === 2) {
            params.append('gender', 'F');
        }
        if (isProximitySearch) {
            params.append('pin', `${clubLocation.latLng[0]}, ${clubLocation.latLng[1]}`);
            // our elastic index only has lngLat as a geo_point mapping
            params.append('sort', 'location.lngLat');
        }
        if (searchParams) {
            const entries = Object.entries(searchParams);
            for (const [key, value] of entries) {
                if (Array.isArray(value)) {
                    value.forEach((v, i) => {
                        params.append(key, value[i]);
                    });
                } else {
                    params.append(key, value);
                }
            }
        }

        const that = this;
        const { CancelToken } = axios;

        if (query.length > 0) {
            if (that.cancel !== undefined) {
                that.cancel();
            }
            axiosInstance.get('v2/search/players', {
                cancelToken: new CancelToken(((c) => {
                    that.cancel = c;
                })),
                params,
            }).then((response) => {
                const { hits, total } = response.data;
                that.setState({
                    options: (skip ? [...that.state.options, ...hits] : hits),
                    isLoading: false,
                    isEnd: hits.length < 10,
                    skip: skip + 10,
                    searched: true,
                });
            }).catch((error) => {
                console.log(error);
                that.setState({
                    isLoading: false,
                    searched: true,
                });
            });
        } else {
            this.setState({
                isLoading: false,
                showDropDown: false,
                options: [],
                query: '',
                skip: 0,
                isEnd: false,
                searched: true,
            });
        }
    }

    loadMoreItems() {
        console.log('loadMoreItems', this.state.skip);
        const { isEnd } = this.state;
        if (!this.state.isLoading && !isEnd) {
            this.setState({
                isLoading: true,
            }, () => {
                this.fetchSearchResults();
            });
        }
    }

    handleLinkClick(player) {
        // this.props.expandSearch(false);
        if (this.props.clearAfterSelect) {
            this.setState({
                query: '',
                showDropDown: false,
            });
        }
        if (this.props.closeAfterSelect) {
            this.setState({
                query: player.displayName,
                showDropDown: false,
            });
        }
        this.props.handlePlayerSelect(player, this.props.index);
    }

    handleSearchBackClick() {
        this.setState({
            isLoading: false,
            showDropDown: false,
            options: [],
            query: '',
            skip: 0,
            isEnd: false,
            searched: false,
        });
    }

    // prevent the fixed positioned div from scrolling the body
    preventDefault(e) {
        e.preventDefault();
    }

    render() {
        const { sportTypeId, checkGate, featureGates, 'data-testid': dataTestId } = this.props;
        const { user } = this.props.auth;
        const isInvitePartnerFlowEnabled = checkGate(featureGates.INVITE_PARTNER_DUB_REG_FLOW);

        const renderPlayer = (player, i) => {
            const { displayName, gender, location, playerProfileImages } = player;
            const userIsPowered = (user && user.isPowered) || false;
            const tennisRating = getRatingDetails(setRatingChoice({ player }), userIsPowered, false, false, false);
            const pickleballRating = getPickleBallRating(player, null);
            let rating;
            if (sportTypeId === sportTypeIds.TENNIS) {
                rating = tennisRating?.value;
                if (tennisRating.showPBRRating) {
                    rating = tennisRating.pbrRating?.ratingDisplay;
                }
            } else if (sportTypeId === sportTypeIds.PICKLEBALL) {
                rating = pickleballRating?.value;
            }
            const descriptionItems = [
                ...(gender ? [gender] : []),
                ...(rating ? [rating] : []),
                ...(location?.display ? [location.display] : []),
            ];
            return (
                <div className={`row ${styles.globalSearchDropdownOption}`} onClick={() => this.handleLinkClick(player)} key={`p${i}`} data-testid={dataTestId && `${dataTestId}.dropdown.option-${i}`}>
                    <div className="col-2">
                        <BackgroundImage
                            baseUrl={'/v1/player/'}
                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                            images={playerProfileImages}
                            imageType={'thumbnail'}
                            extraCls={'playerThumbnailImage'}
                        />
                    </div>
                    <div className="col-10">
                        <div className={`${styles.name} show-ellipsis`} data-testid={dataTestId && `${dataTestId}.dropdown.option-${i}.name`}><span dangerouslySetInnerHTML={{ __html: displayName }} /> {rating.verified ? <i className="utr-icon icon-verified-blue d-inline-block" /> : ''}</div>
                        <div className={`${styles.place} show-ellipsis`}>
                            <Description desc={descriptionItems} />
                        </div>
                    </div>
                </div>
            );
        };

        const renderDropdown = () => {
            return (
                <div className="pb24">
                    {this.state.options.length === 0 && !this.state.isLoading && (
                        <div className={styles.globalSearchDropdownNoMatches} data-testid={dataTestId && `${dataTestId}.dropdown.no-matches`}>
                            {this.props.excludeNonEligiblePlayers ? (
                                <>
                                    {this.state.searched ? (
                                        <div className="text-small p8">
                                            <div className="text-bold">The entered partner name is not eligible.</div>
                                            You can search again with a different name or register in the <span className="text-bold">Need partner</span> section. For questions, please contact the event provider at <span className="text-bold">{this.props.eventProviderEmail}</span>
                                        </div>
                                    ) : 'Add a player by name or email'}
                                </>
                            )
                                : (
                                    <>
                                        {!this.state.searched ? 'Add a player by name or email' : 'No Matches Found'}
                                    </>
                                )}
                            {this.state.searched && this.state.emailTextInput && (
                                <div className="mt8">You can invite a new player by entering their email address</div>
                            )}
                        </div>
                    )}
                    {(this.state.options.length > 0 || this.state.isLoading) && (
                        <div className={styles.globalSearchDropdownOptions} data-testid={dataTestId && `${dataTestId}.dropdown.options-list`}>
                            {this.state.options.map((player, i) => renderPlayer(player.source, i))}
                            {this.state.isLoading && (
                                <div className={styles.loading} data-testid={dataTestId && `${dataTestId}.dropdown.loading`}><i className="fas fa-circle-notch fa-spin" />Loading...</div>
                            )}
                            {!this.state.isLoading && (
                                <Waypoint
                                    onEnter={this.loadMoreItems}
                                    threshold={2.0}
                                />
                            )}

                        </div>
                    )}
                </div>
            );
        };

        return (
            <div className={`${styles.globalSearchContainer} ${styles.lookup} ${styles.themeV3}`} ref={this.setWrapperRef} data-testid={dataTestId || undefined}>
                <div className={`${styles.globalSearchInputContainer} ${this.state.showDropDown ? styles.showOnTop : ''} ${themeV3styles.inputWrapper}`}>
                    {this.state.showDropDown && (
                        <span
                            className={`d-block d-lg-none fas fa-chevron-left ${styles.feedbackLeft}`}
                            onClick={this.handleSearchBackClick}
                            data-testid={dataTestId && `${dataTestId}.back-btn`}
                        />
                    )}
                    <input
                        autoFocus={!!this.props.autoFocus}
                        type="text"
                        value={this.state.query}
                        className={`${styles.globalSearchInput} ${this.props.className} ${this.state.showDropDown ? 'dropdown-open' : ''} ${themeV3styles.formControl}`}
                        onChange={this.handleKeyUp}
                        onPaste={this.handlePaste}
                        onFocus={this.handleOnFocus}
                        placeholder={this.props.placeholder ? this.props.placeholder : 'Search by name or email'}
                        data-testid={dataTestId && `${dataTestId}.input`}
                    />
                    {this.state.error && <div className={`${styles.error}`} data-testid={dataTestId && `${dataTestId}.error`}>{this.state.error}</div>}
                    {this.props.showSearchClearIcon && this.state.query.length > 0 && (
                        <span
                            className={`form-control-feedback fas fa-times-circle ${styles.feedbackRight}`}
                            onClick={this.handleSearchBackClick}
                            data-testid={dataTestId && `${dataTestId}.clear-btn`}
                        />
                    )}
                </div>
                {this.state.showDropDown && (
                    <div className={`player-search-dropdown ${styles.globalSearchDropdownContainer} ${this.props.showInvitePlayer ? 'pb60' : ''}`} data-testid={dataTestId && `${dataTestId}.dropdown`}>
                        {renderDropdown()}
                        {!this.props.excludeNonEligiblePlayers && this.state.searched && this.props.showInvitePlayer && isInvitePartnerFlowEnabled && (
                            <div className="invite-player" onClick={(e) => { e.stopPropagation(); this.handleLinkClick({ query: this.state.query }); }} data-testid={dataTestId && `${dataTestId}.invite-player`}>
                                <div className="row">
                                    <div className="col-2 d-flex align-items-center">
                                        <div className="icon circled-add" />
                                    </div>
                                    <div className="col-10 text-dark" data-testid={dataTestId && `${dataTestId}.invite-player.label`}>
                                        Can&apos;t find your partner?<br />Invite <b>{this.state.query}</b> now!
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

PlayerSearch.propTypes = {
    onChange: PropTypes.func,
    sportTypeId: PropTypes.number,
    excludeNonEligiblePlayers: PropTypes.bool,
    eventId: PropTypes.number,
    eventProviderEmail: PropTypes.string,
    showInvitePlayer: PropTypes.bool,
    claimed: PropTypes.bool,
    checkGate: PropTypes.func,
    featureGates: PropTypes.objectOf(any),
    autoFocus: PropTypes.bool,
    'data-testid': PropTypes.string,
};

PlayerSearch.defaultProps = {
    onChange() { },
    sportTypeId: sportTypeIds.TENNIS,
    excludeNonEligiblePlayers: false,
    eventId: null,
    eventProviderEmail: '',
    showInvitePlayer: false,
    claimed: false,
    autoFocus: false,
    checkGate: () => false,
    featureGates: PropTypes.shape({
        INVITE_PARTNER_DUB_REG_FLOW: PropTypes.string,
    }),
    'data-testid': null,
};

function mapStateToProps({ auth }) {
    return { auth };
}

export default withStatsig(withRouter(connect(mapStateToProps)(PlayerSearch)));
